import { jsx as _jsx } from "react/jsx-runtime";
/**
 * CommentAuthorAvatar — small circular avatar surfaced alongside a
 * comment's body text.
 *
 * Same identity contract as the lip avatar
 * (`AttributionIdentity`): an `avatarSrc` if the team has a hardcoded
 * portrait for the resolved user, else an uppercased initial. This
 * component just paints whichever the resolver hands it — the lookup
 * itself lives in `useAccountIdentity`.
 *
 * Two surfaces consume this: the in-panel comment popover (rendered
 * by `CommentAnnotationView` for `text_range` comments) and the
 * left-of-panel comments rail (rendered by
 * `BlockDetailCommentsRailContainer`). Both want the same chrome —
 * one component, two callers.
 */
import { memo } from "react";
import "./comment-author-avatar.scss";
export const CommentAuthorAvatar = memo(function CommentAuthorAvatar({ identity, }) {
    return (_jsx("span", { className: "comment-author-avatar", "aria-hidden": true, children: identity.avatarSrc ? (_jsx("img", { src: identity.avatarSrc, alt: "", className: "comment-author-avatar__image" })) : (_jsx("span", { className: "comment-author-avatar__initial", children: identity.initial })) }));
});
